import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';
import ComponentsCollection from 'js/models/components.collection';

    export default GenericModel.extend({
        model: {
            components: ComponentsCollection
        },
        defaults: {
            components: new ComponentsCollection()
        },
        parse: function (response) {
            _.keys(this.model).forEach(key => {
                var embeddedClass = this.model[key];
                var embeddedData = response[key];
                response[key] = new embeddedClass(embeddedData, {parse: true});
            });
            return response;
        },
        initialize: function () {
            var self = this;
            self.get('components').on('change', function (model) {
                var index = self.get('components').indexOf(model);
                _.forEach(model.changed, function (val, key) {
                    self.changed[`components[${index}].${key}`] = val;
                });
                self.trigger('change', self);
            });
            self.on('sync', function (e) {
                self.get('components').trigger('sync', e);
                self.changed = {};
            });
        }
    });
